import BreadcrumbList from './breadcrumb';
import BreadcrumbItem from './breadcrumb-item';

export type { BreadcrumbProps } from './breadcrumb';

const Breadcrumb = {
  List: BreadcrumbList,
  Item: BreadcrumbItem,
};

export default Breadcrumb;
